import { Component, inject, OnDestroy, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { BillViewComponent } from './bill-view.component';
import { Bill, BillDataService } from '../bill-data.service';
import { AutoCloseOverlayMixin } from '../../../../shared/mixins/auto-close-overlay.mixin';

@Component({
  selector: 'app-bill-overlay',
  standalone: true,
  imports: [BillViewComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    @if (bill()) {
      <app-bill-view [bill]="bill()!" (billUpdated)="onBillUpdated($event)" />
    }
  `,
})
export class BillOverlayComponent extends AutoCloseOverlayMixin implements OnInit, OnDestroy {
  private config = inject(DynamicDialogConfig);
  private billDataService = inject(BillDataService);

  bill = signal<Bill | undefined>(undefined);
  private closeSubscription$ = new Subject<void>();

  constructor() {
    super();
    this.bill.set(this.config.data.bill);
  }

  override ngOnInit(): void {
    super.ngOnInit();

    // Reload bill data to ensure we have all fields including pdfDocumentId
    const currentBill = this.bill();
    if (currentBill) {
      this.billDataService
        .getById(currentBill.id)
        .pipe(takeUntil(this.closeSubscription$))
        .subscribe({
          next: (bill) => this.bill.set(bill),
          error: (err) => console.error('Failed to reload bill:', err),
        });
    }
  }

  override ngOnDestroy(): void {
    this.closeSubscription$.next();
    this.closeSubscription$.complete();
    super.ngOnDestroy();
  }

  onBillUpdated(updatedBill: Bill): void {
    this.bill.set(updatedBill);
    // Update dialog header with new status if needed
    if (this.config.header) {
      this.config.header = `Invoice ${updatedBill.completeBillNumber}`;
    }
  }
}
